import { useTranslation } from 'react-i18next';

import { AllTaskCompletedWrapper, Subtitle, Title } from './AllTaskCompleted.styles';

export const AllTaskCompleted = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  return (
    <AllTaskCompletedWrapper>
      <Title>{t('ALL_TASKS_COMPLETED')}</Title>
      <Subtitle>{t('ALL_TASKS_COMPLETED_SUBTITLE')}</Subtitle>
    </AllTaskCompletedWrapper>
  );
};
